import SplitType from 'split-type'
gsap.registerPlugin(ScrollTrigger);

export default class TopFunc {
  constructor() {

    this.moveKvImage()
    this.showProgressBar()
    this.controlSideNav()
    this.changeGotopIcon()
    this.controlSounds()
    this.splitText()
    this.scaleContent()

    // ロード後にトリガー位置を再計算
    document.addEventListener('DOMContentLoaded', () => {
      ScrollTrigger.refresh();
    });

  }

  // キービジュアルの画像をマウスの動きに連動させる
  moveKvImage() {
    const hoverArea = document.body;
    const hoverImage = document.querySelector('#js-hoverImage');
    const hoverImageBg = document.querySelector('#js-hoverImageBg');

    if (!hoverArea || !hoverImage) return;
    if ( window.innerWidth < 768 ) return;

    hoverArea.addEventListener('mousemove', function(event) {
      const xPos = event.pageX - hoverArea.offsetLeft;
      const yPos = event.pageY - hoverArea.offsetTop;
      const xOffset = 60;
      const yOffset = 60;

      const xMove = (xPos / hoverArea.offsetWidth - 0.5) * xOffset;
      const yMove = (yPos / hoverArea.offsetHeight - 0.5) * yOffset;

      hoverImageBg.style.transform = `translate(${xMove}px, ${yMove}px)`;
      hoverImage.style.transform = `translate(${xMove * 0.5}px, ${yMove * 0.5}px)`;
    });

    // hoverArea.addEventListener('mouseleave', function() {
    //   hoverImageBg.style.transform = 'translate(0, 0)';
    //   hoverImage.style.transform = 'translate(0, 0)';
    // });
  }

  // プログレスバー
  showProgressBar() {
    const ProgressBar = require('./progressbar.js')
    const barElem = document.querySelector('#js-progressBar');
    if (!barElem) return;
    var bar = new ProgressBar.Line('#js-progressBar', {
      easing: 'easeInOut',
      duration: 1400,
      color: '#F24BCF',
      trailColor: '#5C32D4',
      svgStyle: {width: '100%', height: '100%'},

    });

    bar.animate(1.0, () => {
      document.querySelector('#intro').classList.add('is-loaded');
    });
  }

  // サイドナビゲーション
  controlSideNav() {
    const sideNav = document.querySelector('#js-sideNav');
    const popup = document.querySelector('#popup');
    const sideNavItems = gsap.utils.toArray('#js-sideNav li');
    const sections = gsap.utils.toArray('.js-section');

    if (!sideNav || !sideNavItems || !sections) return;

    // サイドナビゲーションの表示・非表示
    ScrollTrigger.create({
      trigger: document.querySelector('#project'),
      start: "top 60px",
      end: "bottom 60px",
      // markers: true,
      onEnter: () => {
        sideNav.classList.add('is-visible');
        if ( popup !== null ) { popup.classList.add('is-visible'); }
      },
      onLeaveBack: () => {
        sideNav.classList.remove('is-visible');
        if ( popup !== null ) { popup.classList.remove('is-visible'); }
      }
    });

    // アクティブ表示の切り替え
    sections.forEach((section, index) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top 50%",
        end: "bottom 50%",
        // markers: true,
        onEnter: () => {
          sideNavItems.forEach((item) => {
            item.classList.remove('is-active');
          });
          sideNavItems[index].classList.add('is-active');
        },
        onLeaveBack: () => {
          sideNavItems[index].classList.remove('is-active');
          if (index > 0) {
            sideNavItems[index - 1].classList.add('is-active');
          }
        }
      });
    });
  }

  // アイコンの切り替え
  changeGotopIcon() {
    const gotopIcon = document.querySelector('#js-changeIcon');
    const changeIconTrigger = gsap.utils.toArray('.js-changeIconTrigger');

    if (!gotopIcon || !changeIconTrigger) return;

    ScrollTrigger.create({
      trigger: changeIconTrigger[0],
      start: "top 0%",
      end: "bottom 0%",
      // markers: true,
      onEnter: () => {
        gotopIcon.classList.add('is-visible');
      },
      onLeaveBack: () => {
        gotopIcon.classList.remove('is-visible');
      }
    });

    changeIconTrigger.forEach((trigger, index) => {
      const type = Number(trigger.getAttribute('data-type'));
      ScrollTrigger.create({
        trigger: trigger,
        start: "top 0%",
        end: "bottom 0%",
        // markers: true,
        onEnter: () => {
          gotopIcon.setAttribute('data-type', type);
        },
        onLeaveBack: () => {
          gotopIcon.setAttribute('data-type', type - 1);
        }
      });
    });

  }

  // サウンド再生・停止
  controlSounds() {
    const soundToggle = document.querySelectorAll('.js-soundToggle');
    const audio = document.querySelector('#js-audio');

    if (!soundToggle || !audio) return;

    soundToggle.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const switchTo = toggle.getAttribute('data-switch-to');
        const isIntro = new Boolean(toggle.getAttribute('data-is-intro'));

        // 再生
        if (switchTo === 'on') {
          audio.play();
          document.body.setAttribute('data-sound', 'on');
        }

        // 停止
        if (switchTo === 'off') {
          audio.pause();
          document.body.setAttribute('data-sound', 'off');
        }

        if (isIntro) {
          document.querySelector('#intro').classList.add('is-hidden');
        }
      });
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        audio.pause();
      } else if (document.body.getAttribute('data-sound') === 'on') {
        audio.play();
      }
    });

  }

  // テキスト分割
  splitText() {
    const smoothTexts = gsap.utils.toArray('.js-smoothText');
    smoothTexts.forEach((target) => {
      let SplitClient = new SplitType(target, {
        tagName: 'span',
        types: 'lines',
      });

      let lines = SplitClient.lines;
      lines.forEach((line, index) => {
        gsap.from(line, {
          opacity: 0,
          duration: 0.5,
          delay: 0.1 * index,
          scrollTrigger: {
            // markers: true,
            trigger: target,
            start: "top 80%",
            end: "bottom 80%",
            onEnter: () => {
              if ( !line.classList.contains('is-visible') ) {
                line.classList.add('is-visible');
              }
            }
          }
        });
      });

    });

  }

  scaleContent() {
    const popup = document.querySelector('#popup');
    const windowWidth = window.innerWidth;
    if (!popup) return;
    if ( windowWidth > 1440 ) {
      popup.style.transform = `scale(${windowWidth / 1440})`;
    }
  }
}
